import type { ComponentType, ReactNode } from 'react'

import { safeExternalUrl } from '@/Ship/Helpers/safeExternalUrl'

import { BaseFieldTemplate } from './BaseFieldTemplate'
import { BaseViewFieldTemplate } from './BaseViewFieldTemplate'

// Шаблони ядра/Ship написані на JSX без типів пропсів
const FieldTemplate = BaseFieldTemplate as ComponentType<any>
const ViewFieldTemplate = BaseViewFieldTemplate as ComponentType<any>

interface LinkFieldTemplateProps {
    field: any
    formContext: any
    /** У редагуванні — інпут, у перегляді ядро передає сире значення поля */
    children?: ReactNode
}

/**
 * Шаблон поля з URL (`template` у визначенні поля): у перегляді http(s)-адреса стає
 * посиланням у новій вкладці, решта значень — звичайним текстом; у редагуванні —
 * звичайний шаблон. Через `template`, а не `view`, бо `view` ядро рендерить без лейбла.
 */
export const LinkFieldTemplate = ({ field, formContext, children }: LinkFieldTemplateProps) => {
    const isEditable =
        formContext?.isEditable !== false && field?.isEditable !== false && field?.definition?.isEditable !== false
    if (isEditable) {
        return <FieldTemplate field={field}>{children}</FieldTemplate>
    }

    const href = safeExternalUrl(children)
    return (
        <ViewFieldTemplate field={field}>
            {href ? (
                <a href={href} target="_blank" rel="noopener noreferrer">
                    {String(children).trim()}
                </a>
            ) : (
                children
            )}
        </ViewFieldTemplate>
    )
}
